<template>
  <div class="dd-home">
    <Header out-of-flow transparent/>
    <FirstScreen/>
    <Tabs class="dd-home__tabs" :active.sync="active">
      <div :slot="item.name" :text="item.text" v-for="item in tabItems" :key="item.name">
        <VideoList v-if="item.data.length" :data="item.data" @reachBottom="handleReachBottom(item)"/>
        <div class="dd-home__tabs-empty">暂无数据</div>
      </div>
    </Tabs>
    <Footer/>
  </div>
</template>

<script>
import request from '@/common/request'

export default {
  data () {
    return {
      tabItems: [
        {
          name: 'us',
          text: '我们的视频',
          isLoading: false,
          isComplete: false,
          isPartner: false,
          currentPage: 1,
          data: []
        },
        {
          name: 'partner',
          text: '合作方视频',
          isLoading: false,
          isComplete: false,
          isPartner: true,
          currentPage: 1,
          data: []
        }
      ],
      limit: 20,
      active: 'us'
    }
  },
  watch: {
    active: {
      immediate: true,
      handler (value) {
        const tabItem = this.tabItems.find(item => item.name === value)
        if (!tabItem.data.length) {
          this.fetchData(tabItem)
        }
      }
    }
  },
  methods: {
    fetchData (tabItem) {
      if (tabItem.isLoading) return
      tabItem.isLoading = true
      request({
        url: `//datadove-api.jin10.com/getVideos`,
        params: {
          isPartner: tabItem.isPartner ? 1 : 0,
          page: tabItem.currentPage,
          limit: this.limit
        }
      }).then(res => {
        tabItem.data.push(...res.data)
        tabItem.currentPage++
        tabItem.isLoading = false
        if (res.data.length < this.limit) {
          tabItem.isComplete = true
        }
      })
    },
    handleReachBottom (item) {
      if (item.isComplete) return
      this.fetchData(item)
    }
  }
}
</script>

<style lang="scss">
.dd-home {
  height: 100%;

  &__tabs {
    @extend %wrap;
    box-sizing: border-box;

    &-empty {
      text-align: center;
      color: rgba(255,255,255, .5);
      padding: 100px 0;
    }
  }
}
</style>
